import { Typography } from 'antd'
import { ParagraphProps } from 'antd/es/typography/Paragraph'

type TextSize = 'sm' | 'md' | 'lg' | 'xl' | 'xxl'

type TextWeight = 400 | 500 | 600 | 700

type Props = {
  size?: TextSize
  weight?: TextWeight
  color?: string
} & ParagraphProps

export const textSize = {
  sm: '10px',
  md: '12px',
  lg: '14px',
  xl: '16px',
  xxl: '18px'
}

export const Paragraph = ({
  size = 'lg',
  weight = 500,
  color = 'inherit',
  children,
  className,
  ...props
}: Props) => {
  return (
    <Typography.Paragraph
      className={className}
      style={{
        fontSize: textSize[size],
        fontWeight: weight,
        color,
        margin: 0
      }}
      {...props}
    >
      {children}
    </Typography.Paragraph>
  )
}
